import { Cloud, Cpu, Microscope, Sparkles } from "lucide-react";

export interface MenuItem {
  title: string;
  url: string;
  description?: string;
  icon?: React.ReactNode;
  items?: MenuItem[];
  external?: boolean;
  prefetch?: boolean;
}

// This is the content for the header, that lives in either the desktop or mobile header
export const headerMenu: MenuItem[] = [
  {
    title: "Products",
    url: "#",
    items: [
      {
        title: "Models",
        description: "State-of-the-art vision language models",
        icon: <Sparkles className="size-5 shrink-0" />,
        url: "/p/models",
      },
      {
        title: "Lens",
        description: "Fine-tune Moondream for your use case",
        icon: <Microscope className="size-5 shrink-0" />,
        url: "/p/lens",
      },
      {
        title: "Photon",
        description: "High-performance local inference engine",
        icon: <Cpu className="size-5 shrink-0" />,
        url: "/p/photon",
      },
      {
        title: "Cloud",
        description: "Managed inference in the cloud",
        icon: <Cloud className="size-5 shrink-0" />,
        url: "/p/cloud",
      },
    ],
  },
  {
    title: "Solutions",
    url: "/solutions",
    prefetch: true,
  },
  {
    title: "Playground",
    url: "/me/playground",
    prefetch: true,
  },
  {
    title: "Docs",
    url: "https://docs.moondream.ai",
    external: false,
  },
  {
    title: "Blog",
    url: "/blog",
    prefetch: true,
  },
  {
    title: "Pricing",
    url: "/pricing",
    prefetch: true,
  },
];

export const userMenu: MenuItem[] = [
  {
    title: "Console",
    url: "/me/dashboard",
  },
];
